export const productcolor = [
    'White',
    'Black',
    'Red',
    'Blue',
    'Yellow',
 ];
 export const brandsName = [
    'IndoPrimo',
    'Denim',
    'Mizago',
    'Harpa',
    'Montrez',
    'Campus',
    'Addidas',
    'Puma',
 ];